<template>
  <card-container
    :id="pageId"
    class="brochure"
    :no-action="true"
  >
    <template #title>
      Download Brochures
    </template>

    <template #content>
      <div class="brochure__grid">
        <div
          v-for="brochure in brochures"
          :key="brochure.id"
          class="brochure__card"
        >
          <div class="brochure__card-inner">
            <div class="brochure__card-front">
              <img
                :alt="brochure.title"
                :src="brochure.image"
                class="brochure__image"
              >
              <h4 class="brochure__title">
                {{ brochure.title }}
              </h4>
              <p class="brochure__description">
                {{ brochure.description }}
              </p>
            </div>
            <div class="brochure__card-back">
              <p-button
                class="brochure__button"
                type="primary"
                @click="downloadFile(brochure.link)"
              >
                Download PDF
              </p-button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </card-container>
</template>

<script lang="ts" setup>
import adminDashboardUserGuideImg from '@/assets/img/admin-dashboard-user-guide.png';
import gogoPartnershipHandbookImg from '@/assets/img/gogo-partnership-handbook.png';

const pageId = 'download-brochure';

const brochures = [
  {
    id: 1,
    title: 'Admin Dashboard User Guide',
    description: 'Enabling you to manage users, order rides, view reports, and customize settings for your organization.',
    link: 'https://lob-marketing-collateral.s3.us-west-1.amazonaws.com/GoGoAdmin+Dashboard+User+Guide.pdf',
    image: adminDashboardUserGuideImg,
  },
  {
    id: 2,
    title: 'Gogo Partnership Handbook',
    description:
      'This handbook is designed specifically for program administrators who manage and oversee the GoGo service for their organization.',
    link: 'https://lob-marketing-collateral.s3.us-west-1.amazonaws.com/GoGoPartnership-Handbook.pdf',
    image: gogoPartnershipHandbookImg,
  },
];

const downloadFile = (url: string) => {
  window.open(url, '_blank');
};
</script>

<style lang="scss">
.brochure {
  &__grid {
    display: flex;
    gap: 32px;
    flex-wrap: wrap;
    justify-content: center;
    padding: 16px;
  }

  &__card {
    width: 220px;
    height: 280px;
    perspective: 1000px;

    &-inner {
      width: 100%;
      height: 100%;
      position: relative;
      transform-style: preserve-3d;
      transition: transform 0.5s ease-in-out;
    }

    &:hover &-inner {
      transform: rotateY(180deg);
    }

    &-front,
    &-back {
      width: 100%;
      height: 100%;
      position: absolute;
      backface-visibility: hidden;
      border-radius: 8px;
      overflow: hidden;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }

    &-front {
      background: var(--el-empty-fill-color-9);
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 14px;
      text-align: center;
      gap: 6px;
    }

    &-back {
      background: var(--el-color-primary-light-7);
      background-image: url('@/assets/img/bg-pattern.png');
      color: var(--el-text-color-primary);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      transform: rotateY(180deg);
      padding: 16px;
    }
  }

  &__image {
    width: 100%;
    border-radius: 6px;
    margin-bottom: 8px;
  }

  &__title {
    font-size: 16px;
    font-weight: 600;
    color: var(--el-text-color-primary);
    margin: 0;
    min-height: 50px;
  }

  &__description {
    font-size: 14px;
    text-align: center;
    color: var(--el-text-color-secondary);
    margin-bottom: 12px;
  }

  &__button {
    background-color: var(--el-color-primary-light-3) !important;
    color: var(--el-text-color-primary) !important;
    font-weight: bold;
    padding: 8px 12px;
    border-radius: 6px;
    border: none;
    cursor: pointer;
    transition: background 0.3s ease;

    &:hover {
      background-color: var(--el-color-primary) !important;
      color: var(--el-text-color-regular) !important;
    }
  }
}
</style>
